import { useState, useEffect } from 'react'

export function useMultiHyphenText(title) {
  const [currentTitle, setCurrentTitle] = useState([])

  useEffect(() => {
    // 因為連字號會被視為不同字母而強迫斷開，目前沒找到方法讓他不斷開
    // 所以用 word around 的方式自己找連字號且讓該單字直接換行

    const MULTI_TEXT = 'multi-'
    const multiHyphenIndex = title.indexOf(MULTI_TEXT)

    if (multiHyphenIndex !== -1) {
      const newTitle = []

      const beforeMultiTitle = title.slice(0, multiHyphenIndex - 1)
      const afterMultiTitle = title.slice(multiHyphenIndex - 1)

      newTitle.push(beforeMultiTitle, afterMultiTitle)

      setCurrentTitle(newTitle)
    } else {
      setCurrentTitle([title])
    }
  }, [title])

  return { computedTitle: currentTitle }
}
